<template>
  <basic-container>
    <div class="needs-detail-container">
      <div class="inner-con">
        <DetailTitle 
          :initTitle="title"
          :detailData="detailData"
          @saveState="saveState"
          @addEvent="addEvent"
        >        
        </DetailTitle>

        <!-- 基础信息 -->
        <topBasicInfoLine
          :rightSlot="slotConfig"
          :infoConfig='topInfoConfig'
          :infoData='detailData'
          :showCondition='false'
        >
          <template slot="needsCondition">
            <div class="condition-line">
              需求状态
            </div>
            <div class="condition-word" :class="['stateTopdiv', `color_${detailData['status']}`]">
              {{detailData['status'] == 1?'继续跟踪':detailData['status'] == 2?'需求已转化':detailData['status'] == 3?'无相关需求':'-'}}
            </div>          
          </template>
        </topBasicInfoLine>
        <div class="middle-block" style="margin-bottom: 20px;"></div>
        <!-- 拜访信息 -->
        <el-tabs v-model="activeName">
          <el-tab-pane class="activelabel" label="拜访详情" name="first" v-if="InfoContainerConfigList.length>0">
            <template v-for="(item, index) in InfoContainerConfigList">
              <InfoContainer
                :key="index"
                :infoTitle="item['infoTitle']"
                :contentConfig="item['infoContent']"
                style="margin-top: 20px;"
              >
                <template slot="basicInfo">
                  <Detaillist
                    :detaillist="detaillistConfig"
                    :data="visitsData[index]"
                  />
                  <el-row :gutter="5">
                    <el-col :span="24">
                      <div class="grid_content">
                        <span class="banktitle_content">拜访附件:</span>
                        <span>
                          <template v-for="(i, index) in visitsData[index]['files']">
                            <div class="file_wrapper" :key="index">
                              <a
                                class="file_button"
                                target="_blank"
                                :href="
                                  isWord(i.fileUrl)
                                    ? 'http://doc.taizhoujintou.com:18888/office/xdoc?doc=' +
                                      i.fileUrl
                                    : i.fileUrl
                                "
                                type="text"
                                size="small"
                              >
                                {{ i.fileName }}
                              </a>
                              <i
                                @click="downLoadFile(i.id)"
                                class="el-icon-download del_icon"
                              ></i>
                            </div>
                          </template>
                        </span>
                      </div>
                    </el-col>
                  </el-row>
                </template>
              </InfoContainer>
            </template>
          </el-tab-pane>

          <el-tab-pane class="activelabel" label="拜访详情" name="first" v-else>
            <div class="no-data">暂无拜访数据</div>
          </el-tab-pane>          
        </el-tabs>
      </div>
    </div>
  </basic-container>
</template>
<script>
import DetailTitle from './components/detailTitle.vue'
// import Detaillist from "@/components/detail/detaillist";
import Detaillist from "@/components/detail/contract_currency/detaillist";
import TopBasicInfoLine from "@/components/basicInfo/basicInfo"
import { visitDetailConfig, topInfoConfig, detaillistDemand } from './needsManageConfig'
import InfoContainer from "@/components/infoContainer/infoContainer";
import * as api from "@/api/zd/needsManage";
import * as dictionaries from "@/api/zd/dictionaries"
export default {
  name: 'needsDetail',
  data() {
    return {
      id: '',
      title: '',
      detailData: {},
      topInfoConfig: topInfoConfig(),
      activeName: 'first',
      visitConfig: visitDetailConfig(),
      InfoContainerConfigList: [],
      detaillistConfig: detaillistDemand(),
      visitsData: [],
      configOne: {
        infoTitle: '拜访信息',
        infoContent: [{
          title: '',
          prop: 'basicInfo'
        }]
      },
      slotConfig: {
        slotName: 'needsCondition',
        slotIn: false
      }
    }
  },
  components: {
    DetailTitle,
    TopBasicInfoLine,
    Detaillist,
    InfoContainer
  },
  mounted() {
    this.id = this.$route.params.id
    this.queryDetail()
  },
  watch: {
    '$route.params.id': {
      handler(newId) {
        if(this.$route.path.indexOf('zd/needsManage/needsDetail')> -1){
          this.id = newId
          this.queryDetail()
        }
      }
    }
  },
  // activated() {
  //   this.id = this.$route.params.id
  //   this.queryDetail()
  // },
  methods: {
    // 新增拜访
    addEvent() {
      this.$router.push({ path: `/zd/visit/add/-1`,query: {custDemandId: this.$route.params.id} })
    },
    async queryDetail() {
      let self = this
      this.InfoContainerConfigList = []
      api.getNeedsDetail({id: this.id}).then(res => {
        console.info(res, 'getNeedsDetail')
        self.detailData = res.data.data
        self.detailData.custNames = res.data.data.custName
        delete self.detailData.custName
        self.title = self.detailData.demandName
        // 处理详情数据
        let configOne = JSON.parse(JSON.stringify(self.configOne))
        let arr = Object.getOwnPropertyNames(self.detailData.belongVisit)
        if(arr.length > 0 && arr[0] != '__ob__'){
          self.detailData.visits.push(self.detailData.belongVisit)
        }


        if(self.detailData.visits.length > 0){
          self.detailData.visits.map((item, index) => {
            let num = self.numberToChinese(`${index+1}`)
            self.InfoContainerConfigList.push({
              ...configOne
            })
            self.InfoContainerConfigList[index].infoTitle = `拜访信息${num}`
            // 查询拜访附件
            self.queryFile(item.id).then(fileData => {
                item.files = fileData
            })
          })
        }
        self.visitsData = self.detailData.visits
        // let arr = Object.getOwnPropertyNames(self.detailData.belongVisit)
        // if(arr.length > 0 && arr[0] != '__ob__'){
        //   let belongNum = self.numberToChinese(`${self.detailData.visits.length+1}`)
        //   self.detailData.belongVisit.files = self.queryFile(self.detailData.belongVisit.id)
        //   self.detailData.visits.push(self.detailData.detailData)
        //   self.InfoContainerConfigList.push({
        //       ...configOne
        //   })
        //   self.InfoContainerConfigList[self.InfoContainerConfigList.length - 1].infoTitle = `拜访信息${belongNum}`
        // }
      })
    },

    numberToChinese(str) {
      var num = parseFloat(str);
      var strOutput = ""
        // strUnit = '仟佰拾亿仟佰拾万仟佰拾元角分';
      num += "";
      var intPos = num.indexOf('.');
      if (intPos >= 0){
        num = num.substring(0, intPos) + num.substr(intPos + 1, 2);
      }
      // strUnit = strUnit.substr(strUnit.length - num.length);
      for (var i=0; i < num.length; i++){
        strOutput += '零一二三四五六七八九'.substr(num.substr(i,1),1);
      }
      return strOutput
    },    

    async queryFile(id) {
      let resOne = await dictionaries.getFileMenuByName({ fileMenuName:'客户拜访附件' })
      let baFileMenuId = resOne.data.data.id
      let params = {
        fileOtherId: id,
        baFileMenuId: baFileMenuId
      }
      let resTwo = await dictionaries.findFileByOtherId(params)
      if(resTwo.data.data.length > 0){
        return resTwo.data.data
      }else{
        return []
      }
    },
    // 状态变更
    saveState(form) {
      let params = {
        id: this.detailData.id,
        status: form.state
      }
      api.needsUpdate(params).then(res => {
        console.info(res, 'needsUpdate')
        if(res.data.code == 200){
          this.queryDetail()
          this.$message({
            type: "success",
            message: "更改需求状态成功！"
          });          
        }
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.needs-detail-container{
  // background: #fff;
  // padding-top: 25px;
  // padding-bottom: 25px;
  // position: relative;
.grid_content {
  display: flex;
}
.file_wrapper {
  display: flex;
  align-items: center;
  min-height: 35px;
  .file_button {
    display: contents;
    color: #333333;
    font-weight: 400;
    &:hover {
      color: #409eff;
    }
  }
}
  .banktitle_content {
    color: #999999;
    margin-right: 15px;
  }  
  .inner-con{
    min-width: 1000px;
    max-width: 1100px;
    margin: 0 auto;
    margin-top: 3px;    
  }
  .color_1::before {
    background: #FEC03D;
  }
  .color_2::before {
    background: #51d351;
  }
  .color_3::before {
    background: #ccc !important;
  }
  /deep/.el-tabs__item {
    font-size: 18px;
    font-weight: bolder;
    margin-bottom: 10px;
  }
  .no-data {
    color: #ccc;
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    width: 100%;
    margin-top: 50px;
  }
}
</style>
<style >
.el-tabs__item.is-active {
  padding: 0 20px;
}
</style>